import { Button, Container } from "@mui/material";
import styles from "./HomeConcept.module.scss";
import thumbnail from "Explore/Assets/homepage/homepage-concept.png";
import { IconPack } from "Explore/Config/Icons";

const HomeConcept = () => {
  return (
    <div className={styles["home-concept"]}>
      <Container maxWidth="lg" className={styles["home-concept__container"]}>
        <div className={styles["home-concept__left"]}>
          <p className={styles["home-concept__left--title"]}>Concepts Today</p>
          <p className={styles["home-concept__left--description"]}>
            Moreover, we have over ten million other concepts across various
            fields. You can browse them on the Concepts page.
          </p>
          <Button
            variant="contained"
            className={styles["home-concept__left--button"]}
            href="/explore/concept"
            endIcon={IconPack.arrow}
          >
            Browse Concepts
          </Button>
        </div>
        <div className={styles["home-concept__right"]}>
          <div className={styles["home-concept__right--image__container"]}>
            <img
              className={styles["home-concept__right--image"]}
              src={thumbnail}
              alt="thumbnail"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HomeConcept;
